export default __webpack_public_path__ + "static/media/RequestActive.ffd0ed35.svg";